export const TRANSITION_FOCUS_DELAY_MS = 300
